import React, { createContext, useContext, useState } from "react";

const ResultsContext = createContext(null);

const ResultsProvider = ({ children }) => {
  const [runners, setRunners] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [buildingsTypes, setBuildingsTypes] = useState([]);
  const [connectionTypes, setConnectionTypes] = useState([]);
  const [results, setResults] = useState([]);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState({left: false, right: false});

  return (
    <ResultsContext.Provider
      value={{
        runners,
        setRunners,
        buildings,
        setBuildings,
        buildingsTypes,
        setBuildingsTypes,
        connectionTypes,
        setConnectionTypes,
        results,
        setResults,
        isSidebarCollapsed, 
        setIsSidebarCollapsed
      }}
    >
      {children}
    </ResultsContext.Provider>
  );
};

const useResultsContext = () => {
  return useContext(ResultsContext);
};

export { ResultsProvider, useResultsContext };
